import { lazy, Suspense } from 'react';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.css';

import Layout from './components/layout/Layout';

// Route-based code splitting — each page is loaded only when navigated to
const BridgePage = lazy(() => import('./pages/bridge/BridgePage'));
const Swap = lazy(() => import('./pages/swap/Swap'));

const Bone = ({ className }: { className?: string }) => (
  <div className={`animate-pulse rounded-md bg-white/[0.06] ${className ?? ''}`} />
);

const BridgeSkeleton = () => (
  <main className="flex-1 overflow-auto">
    <div className="min-h-full flex items-center justify-center px-4 pt-24 py-8">
      <div className="flex max-w-[560px] w-full min-w-[320px] border-2 border-border-default/50 bg-action-primary/5 backdrop-blur-xl p-6 rounded-lg flex-col gap-6">
        {/* Header: title + history button */}
        <div className="flex items-center justify-between">
          <Bone className="h-8 w-20" />
          <Bone className="h-9 w-9 rounded-lg" />
        </div>
        {/* Tabs */}
        <Bone className="h-10 w-48" />
        {/* Form */}
        <div className="flex w-full flex-col gap-5">
          {/* Chain select */}
          <Bone className="h-12 w-full rounded-md" />
          {/* Sender section */}
          <div className="flex w-full flex-col gap-2">
            <div className="flex items-center justify-between">
              <Bone className="h-4 w-36" />
            </div>
            <div className="flex items-center justify-between">
              <Bone className="h-7 w-28" />
              <Bone className="h-4 w-32" />
            </div>
            <Bone className="h-14 w-full rounded-md" />
          </div>
          {/* Receiver section */}
          <div className="flex w-full flex-col gap-2">
            <Bone className="h-4 w-28" />
            <Bone className="h-11 w-full rounded-md" />
          </div>
          {/* Transfer button */}
          <Bone className="h-11 w-full rounded-md" />
        </div>
      </div>
    </div>
  </main>
);

const SwapSkeleton = () => (
  <main className="flex-1 overflow-auto">
    <div className="flex min-h-full items-center justify-center px-4 py-8 pt-24">
      <div className="flex max-w-[560px] w-full min-w-[320px] border-2 border-border-default/50 bg-action-primary/5 backdrop-blur-xl p-6 rounded-lg flex-col gap-6">
        {/* Header: title + settings */}
        <div className="flex items-center justify-between">
          <Bone className="h-8 w-16" />
          <Bone className="h-9 w-9 rounded-lg" />
        </div>
        {/* Token selectors */}
        <div className="relative flex w-full gap-8">
          <Bone className="h-14 w-full rounded-md" />
          <Bone className="h-14 w-full rounded-md" />
        </div>
        {/* Amount input */}
        <div className="flex w-full flex-col gap-2">
          <Bone className="h-4 w-36" />
          <Bone className="h-14 w-full rounded-md" />
        </div>
        {/* Button */}
        <Bone className="h-11 w-full rounded-md" />
      </div>
    </div>
  </main>
);

function App() {
  return (
    <Router>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/swap" element={<Suspense fallback={<SwapSkeleton />}><Swap /></Suspense>} />
          <Route path="/bridge" element={<Suspense fallback={<BridgeSkeleton />}><BridgePage /></Suspense>} />
          <Route path="/" element={<Navigate to="/bridge" replace />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
